// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px) and (min-width: 601px)";
var _4 = "header-30f5x";
var _5 = "header__wrapper-3UPf_";
var _6 = "header__title-39uMi";
var _7 = "back-3IUgV";
var _8 = "close-2wmaK";
var _9 = "close_fixed-17LWj";
var _a = "close__text-38bN5";
var _b = "close__icon-trklL";
var _c = "content-2Awxa";
var _d = "content_withoutOffset-1gfLH";
var _e = "withoutPadding-2GIlj";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet_only", _4 as "header", _5 as "header__wrapper", _6 as "header__title", _7 as "back", _8 as "close", _9 as "close_fixed", _a as "close__text", _b as "close__icon", _c as "content", _d as "content_withoutOffset", _e as "withoutPadding" }
export default { "__esModule": _1, "mobile": _2, "tablet_only": _3, "header": _4, "header__wrapper": _5, "header__title": _6, "back": _7, "close": _8, "close_fixed": _9, "close__text": _a, "close__icon": _b, "content": _c, "content_withoutOffset": _d, "withoutPadding": _e }
